import React, { useMemo } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import { Listings } from 'containers/AppContainer/typings';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { MODE_TYPES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import JudgementForNonCompensation from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementForNonCompensation';
import { getNewCivj } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { getVehicleFromSagisInfo } from 'containers/PreOpeningPage/OpposingParty/utils';
import { INCIDENT_TYPE } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';

export interface NonCompensationVehiclesRecapProps {
  intl: IntlShape;
  listings: Listings;
  isManager?: boolean;
  dahirAmount?: any;
  responsabilityShareValue?: string;
  expertises?: any;
  isAppeal?: boolean;
  isRejected?: boolean;
  judgementOnMeritsRequest?: any;
  civjvms?: any;
  civj?: any;
  civjWithNonCompensation?: any;
  isContested?: boolean;
  handleOpenContestation?: Function;
  handleExpertiseChange?: Function;
  civilJudgementType?: any;
  handleCivJvmChange: Function;
  judgementOnMerits: any;
  sagisOpposingParties: any;
  mode?: string;
  modeType?: string;
  judgement: any;
  setJudgement: Function;
  setCivilJudgementUpdateExpertise?: Function;
  setJudgementOnMeritsRequest?: Function;
  expertiseType?: any;
  civilJudgementUpdateExpertise?: any;
  judgementForNonCompensation?: any;
  expertiseJudgementAddDocumentId?: any;
  vehicle?: any;
  civjvmRequest: any;
  setCivjvmRequest: Function;
  setCivilJudgements?: Function;
  civilJudgements?: any;
  judgementAddDocExpertises?: any;
  setCivilJudgementUpdateAccountingExpertise?: Function;
  civilJudgementUpdateAccountingExpertise?: any;
  isDisabled: boolean;
}
const NonCompensationVehiclesRecap: React.FC<NonCompensationVehiclesRecapProps> = ({
  ...props
}): JSX.Element => {
  const currentCivj = useMemo(
    () =>
      get(props.civjWithNonCompensation, 'isDeleted', false)
        ? getNewCivj(
            props.expertises,
            props.civjWithNonCompensation,
            INCIDENT_TYPE.VEHICLE,
          )
        : props.civj,
    [props.civj],
  );

  return (
    <div key={props.civjWithNonCompensation?.id} className="victims">
      <Grid container item spacing={2}>
        <div className="victim-item">
          {featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO) &&
          !isEmpty(
            getVehicleFromSagisInfo(
              get(props.civjWithNonCompensation, 'vehicle.partKey', ''),
              props.sagisOpposingParties,
            ),
          )
            ? get(
                getVehicleFromSagisInfo(
                  get(props.civjWithNonCompensation, 'vehicle.partKey', ''),
                  props.sagisOpposingParties,
                ),
                'registrationNumber',
              )
            : `${get(
                props.civjWithNonCompensation,
                'vehicle.registrationNumber',
                '',
              )}`}
        </div>
        <JudgementForNonCompensation
          listings={props.listings}
          judgementOnMeritsRequest={props.judgementOnMeritsRequest}
          isManager={props.isManager}
          modeType={MODE_TYPES.RECAP}
          judgement={props.judgement}
          setJudgement={props.setJudgement}
          judgementForNonCompensation={props.judgementForNonCompensation}
          civjWithNonCompensation={props.civjWithNonCompensation}
          handleCivJvmChange={props.handleCivJvmChange}
          judgementOnMerits={props.judgementOnMerits}
          dahirAmount={props.dahirAmount}
          civjvm={props.civjvms}
          vehicle={props.vehicle}
          expertiseJudgementAddDocumentId={get(
            props.civjWithNonCompensation,
            'expertiseJudgementAddDocumentId',
          )}
          expertiseType={props.expertiseType}
          civj={currentCivj}
          setCivilJudgementUpdateExpertise={
            props.setCivilJudgementUpdateExpertise
          }
          civilJudgementUpdateExpertise={props.civilJudgementUpdateExpertise}
          setJudgementOnMeritsRequest={props.setJudgementOnMeritsRequest}
          civilJudgementType={props.civilJudgementType}
          civjvmRequest={props.civjvmRequest}
          setCivjvmRequest={props.setCivjvmRequest}
          expertises={props.expertises}
          handleExpertiseChange={props.handleExpertiseChange}
          setCivilJudgements={props.setCivilJudgements}
          civilJudgements={props.civilJudgements}
          isAppeal={props.isAppeal}
          judgementAddDocExpertises={props.judgementAddDocExpertises}
          isDisabled={props.isDisabled}
          setCivilJudgementUpdateAccountingExpertise={
            props.setCivilJudgementUpdateAccountingExpertise
          }
          civilJudgementUpdateAccountingExpertise={
            props.civilJudgementUpdateAccountingExpertise
          }
          isRejected={props.isRejected}
        />
      </Grid>
    </div>
  );
};

export default injectIntl(NonCompensationVehiclesRecap);
